// @flow
import * as React from 'react';
import cx from 'classnames';

import Icon from '../../../basic-components/icon';
import cs from './styles.pcss';

type Props = {
  status?: 'ok' | 'error' | 'inactive',
};

export default function Status({ status = 'ok' }: Props): React.Node {
  // ok 状态保留绿色圆点，error 和 inactive 使用 icon
  if (status === 'ok') {
    return <div className={cx(cs.status, cs.ok)} />;
  }

  // 根据状态选择对应的 icon
  const iconName = status === 'error' ? 'errorIcon' : 'clockIcon';

  return (
    <div className={cx(cs.status, cs[status])}>
      <Icon name={iconName} className={cs.icon} />
    </div>
  );
}
